var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#555",
    fillRule: "evenodd",
    d: "M14.869 13.458A8.001 8.001 0 0 0 2.893 2.893 8 8 0 0 0 13.457 14.87l.043.045 4.242 4.243a1 1 0 0 0 1.414-1.415L14.914 13.5zm-2.077-9.15a6 6 0 1 1-8.485 8.485 6 6 0 0 1 8.485-8.486",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;